import { render, staticRenderFns } from "./CustomerSupport.vue?vue&type=template&id=7ef77578&scoped=true&"
import script from "./CustomerSupport.vue?vue&type=script&lang=js&"
export * from "./CustomerSupport.vue?vue&type=script&lang=js&"
import style0 from "./CustomerSupport.vue?vue&type=style&index=0&id=7ef77578&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef77578",
  null
  
)

export default component.exports